import { PrivateRoute } from '@webapps/reactjs-tech-components';
import { useAuth } from '@webapps/reactjs-tech-components';
import Tutorial from 'components/Tutorial';
import { ROUTES_PATH } from 'config/constants';
import GoogleAuth from 'pages/OAuth/Google';
import LinkedInAuth from 'pages/OAuth/LinkedIn';
import SignIn from 'pages/SignIn/index';
import SignUp from 'pages/Signup';
import ConfirmSignUp from 'pages/Signup/ConfirmSignUp';
import InviteExternal from 'pages/Invite/External';
import { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import OOdriveCallback from 'pages/OOdrive';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import ClassesShare from 'pages/school/ClassesPage/ClassesShare';
import Playground from 'pages/Playground';

import Layout from './Layout';
import PrivateApp from './PrivateApp';

const App = () => {
  const TRACKING_ID = 'G-TQDQWYP1J2';
  const location = useLocation();
  const [showTutorial, setShowTutorial] = useState(false);
  const { isPremium, apiToken } = useAuth();
  const { NX_PLAYGROUND } = process.env;

  const playground = NX_PLAYGROUND === 'true';

  ReactGA.initialize(TRACKING_ID);

  useEffect(() => {
    window.axeptioSettings = {
      clientId: '6220f5d94a9f46b0654a8e05',
    };
    (function axeptio(dAxeptio, sAxeptio) {
      const t = dAxeptio.getElementsByTagName(sAxeptio)[0];
      const e = dAxeptio.createElement(sAxeptio);
      e.async = true;
      e.src = '//static.axept.io/sdk.js';
      t.parentNode.insertBefore(e, t);
    })(document, 'script');
  }, []);

  useEffect(() => {
    if (
      location.pathname === ROUTES_PATH.GOOGLE_OAUTH ||
      location.pathname === ROUTES_PATH.LINKEDIN_OAUTH ||
      location.pathname === ROUTES_PATH.SCHOOL_MESSAGES ||
      location.pathname === ROUTES_PATH.BUSINESS_MESSAGES ||
      location.pathname === ROUTES_PATH.SIGN_IN ||
      location.pathname === ROUTES_PATH.SIGN_UP ||
      location.pathname === ROUTES_PATH.FORGOT_PWD ||
      location.pathname === ROUTES_PATH.FORGOT_NEW_PWD ||
      location.pathname === ROUTES_PATH.CONFIRM_SIGNUP
    ) {
      return;
    } else {
      (function (d, w, c) {
        w.BrevoConversationsID = '625d68baccf62c3339332830';
        w[c] =
          w[c] ||
          function () {
            (w[c].q = w[c].q || []).push(arguments);
          };
        var s = d.createElement('script');
        s.async = true;
        s.src = 'https://conversations-widget.brevo.com/brevo-conversations.js';
        if (d.head) d.head.appendChild(s);
      })(document, window, 'BrevoConversations');
    }
  }, [location]);

  useEffect(() => {
    if (location?.state?.tutorial) {
      setShowTutorial(true);
    }
  }, [location]);

  return (
    <>
      {isPremium !== null && (
        <Tutorial
          showTutorial={showTutorial}
          setShowTutorial={setShowTutorial}
        />
      )}
      <Switch>
        {!apiToken && (
          <Route exact path={ROUTES_PATH.SIGN_UP}>
            <SignUp />
          </Route>
        )}
        {!apiToken && (
          <Route exact path={ROUTES_PATH.GOOGLE_OAUTH}>
            <GoogleAuth />
          </Route>
        )}
        {!apiToken && (
          <Route exact path={ROUTES_PATH.LINKEDIN_OAUTH}>
            <LinkedInAuth />
          </Route>
        )}
        {!apiToken && (
          <Route exact path={ROUTES_PATH.SIGN_IN}>
            <SignIn />
          </Route>
        )}
        {!apiToken && (
          <Route exact path={ROUTES_PATH.CONFIRM_SIGNUP}>
            <ConfirmSignUp />
          </Route>
        )}
        {playground && (
          <Route exact path={ROUTES_PATH.PLAYGROUND}>
            <Playground />
          </Route>
        )}
        <Route exact path={ROUTES_PATH.OODRIVE_CALLBACK}>
          <OOdriveCallback />
        </Route>
        <Route exact path={ROUTES_PATH.SHARE_CLASSROOM}>
          <ClassesShare />
        </Route>
        <Route exact path={ROUTES_PATH.INVITE_EXTERNAL}>
          <InviteExternal />
        </Route>
        <PrivateRoute
          path={ROUTES_PATH.HOME}
          routeRedirection={ROUTES_PATH.SIGN_IN}
        >
          <Layout>
            <PrivateApp />
          </Layout>
        </PrivateRoute>
        <Redirect from="*" to={ROUTES_PATH.SIGN_IN} />
      </Switch>
    </>
  );
};

export default App;

const RouteWrapper = ({ condition, children }) => (condition ? children : null);